import Styled, { css } from 'styled-components';

import { media } from '../../lib/StyledComponents';
import { cssDeclaration } from '../_ThemeTwo_/Utils/Styles/cssDeclaration';

export const HeaderBreadcrumbs = Styled.ul`
  order: 2;
  justify-content: space-between;
  padding: 1em;
  border-top: 1px solid ${props => props.theme.colorSlate5};
  height: 100%;

  ${media.medium`
    flex: 0 1 60%;

    /* override mobile */
    padding: 1.5em 0;
    display: block;
    border: none;
  `}
`;

export const HeaderBreadcrumbIcon = Styled.span`
  display: inline-block;
  padding-right: 0.25em;
  color: ${({ theme: { link } }) => link.colorLink};
  ${({ theme: { themeTwo, header }}) => header.breadcrumbIcon && header.breadcrumbIcon.margin && css`
    padding: 0;
    /* margin */  ${cssDeclaration(themeTwo, 'margin', header.breadcrumbIcon.margin)};
  `}

  svg {
    width: 10px;
    height: 10px;
    fill: currentColor;

    ${({theme: { header }}) => header.breadcrumbIcon && css`
      width: ${header.breadcrumbIcon.size && header.breadcrumbIcon.size};
      height: ${header.breadcrumbIcon.size && header.breadcrumbIcon.size};
      fill: ${header.breadcrumbIcon.color && header.breadcrumbIcon.color};
      transform: ${header.breadcrumbIcon.transform && header.breadcrumbIcon.transform};
    `}
  }
`;

export const HeaderBreadcrumbIconMobile = Styled(HeaderBreadcrumbIcon)`
  ${media.medium`
    display: none;
  `}
`;

HeaderBreadcrumbIcon.displayName = 'HeaderBreadcrumbIcon';

export const HeaderBreadcrumb = Styled.li`
  display: inline-block;
  white-space: nowrap;

  &:not(:first-child) {
    display: none;
  }

  a {
    text-decoration: none;
    color: ${({ theme: { link } }) => link.colorLink};
  }

  a:hover {
    color: ${({ theme: { link } }) => link.colorLinkHover};

    svg {
      fill: currentColor;
    }
  }

  ${props => css`
    ${media.medium`
      a::before {
        padding-right: 0;
        content: '';
      }

      &:not(:first-child) {
        display: inline-block;
      }

      &:last-child a {
        color: ${props.theme.header.colorBreadcrumbText};
        cursor: default;
      }

      &:not(:last-child)::after {
        padding: 0 0.5em;
        content: '\\002F';
      }
    `}
  `}
`;

HeaderBreadcrumb.displayName = 'HeaderBreadcrumb';
